import { get } from "lodash";
import { useApplyLang } from "../hooks/use-apply-lang";
export var PLATFORM_PROVIDER_VALUE_OPTIONS_DEFAULT = {
  applyLang: true
};
export function platformProviderValue(data, path, defaultValue, options) {
  if (data === void 0) {
    data = {};
  }
  if (path === void 0) {
    path = '';
  }
  if (defaultValue === void 0) {
    defaultValue = [];
  }
  if (options === void 0) {
    options = PLATFORM_PROVIDER_VALUE_OPTIONS_DEFAULT;
  }
  var dataValue = get(data, "platform.".concat(path), defaultValue);
  if (options.applyLang) {
    return useApplyLang(dataValue);
  }
  return dataValue;
}